import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';

import VehicleDetails from 'Components/AddTrip/VehicleDetails';
import StopDetails from 'Components/AddTrip/StopDetails';
import BiddingDetails from 'Components/AddTrip/BiddingDetails';
import LCLStopDetails from 'Components/AddTrip/LCLStopDetails';
import LegDetails from 'Components/AddTrip/LegsDetails';
import Costs from 'Components/AddTrip/Costs';
import MinimizedTrip from 'Components/AddTrip/MinimizedTrip';

import { ReactComponent as CloseIcon } from 'Icons/close.svg';
import { ReactComponent as MinimizeIcon } from 'Icons/minimize.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg'
import { TAT_UNITS, PAYM, AVG_DISTANCE, KRBL, CARGIL, BEAM, DEEPAK_PHENOLICS_SAP, ARDEX } from 'Constants/commonConstants';
import { GET_LPP_DETAILS, GET_ROUTE_CODE, SAVE_ROUTE_CODE, GET_SYSTEM_SUGGESTED_PRICE, GET_DIESEL_PRICE,GET_SAP_ROUTE_CODES, GET_LOCATION_WITH_PINCODE, CHECK_FTL_CONTRACT_EXIST, GET_MASTER_ROUTE_CODE_DETAILS } from 'Constants/actionConstants';

import Trip from 'Models/Trip';

// import LadyImage from 'Icons/lady.png';
import TruckPreview from 'Icons/truckPreview2.png';

import Heading from 'Components/Heading';

import LivePreview from 'Components/AddTrip/LivePreview';

import TripStatusBar from 'Components/AddTrip/TripStatusBar';

import Overlay from 'Components/Overlay';
import { getUser } from 'Utils/storage';
import { isAdaniWilmar,isDesmet, isGreenPly } from 'Utils/index';
import { GREEN_PLY, CENTURY_PLY, EMAMI, ROQUETTE, STAR_CEMENT } from 'Constants/commonConstants';
import { DEEPAK_PHENOLICS } from 'Constants/commonConstants';
import Confirmation from 'Components/ConfirmationPopup';
import Moment from 'moment';


class AddTrip extends Component {
    constructor(props) {
        super(props);
        const trip = props.trip || new Trip();
        this.viewMode = props.viewMode;
        
        const { 
            //Keep this as it is even if its not required. Client might ask to prefill again :P
            vehicleTypes,
            vehicleBodyTypes,
            paymentCycles,
            businessVolumes,
            pricingBasis,
            qbr,
            rfqServiceType, 
            rfqType,
            disablePlacementTime,
            to,
            from,
            remarks,
            rfqBiddingDetails,
            diesel_price
        } = props;
        
        if(!props.trip) {
            trip.addStop();
            trip.addStop();
            trip.addLCLStop();
            trip.addLeg();
            trip.addCost();

            //Presetting values for Trips
            if(rfqServiceType === 1 || rfqServiceType === 4) {
                // trip.setVehicleType(vehicleTypes[0].value, vehicleTypes[0].name);
                // trip.setVehicleBodyType(vehicleBodyTypes[0].value, vehicleBodyTypes[0].name);
            }
            trip.biddingDetails.setPricingBasis(pricingBasis[0]);
            trip.biddingDetails.setPaymentCycle(paymentCycles[0]);
            trip.biddingDetails.setBusinessVolumeUnit(businessVolumes[0]);
            trip.biddingDetails.setTatUnit(TAT_UNITS[0]);
            trip.biddingDetails.setPaymentTerms(2, null, 'To Be Billed');

            trip.biddingDetails.setPricingBasis( {
                value: rfqBiddingDetails.pricingBasis,
                name: rfqBiddingDetails.pricingBasisName
            });
            trip.biddingDetails.setPaymentCycle( {
                value: rfqBiddingDetails.paymentCycle,
                name: rfqBiddingDetails.paymentCycleName
            });
            trip.biddingDetails.setPaymentTerms(rfqBiddingDetails.paymentTerms, null , rfqBiddingDetails.paymentTerms === 2 ? 'To Be Billed' : 'To Pay');
            trip.biddingDetails.setFrom(rfqBiddingDetails.from);
            trip.biddingDetails.setTo(rfqBiddingDetails.to);
            {diesel_price && trip.biddingDetails.setDieselprice(diesel_price)}
        }
        this.state = {
            activeView: (((rfqType === 1 && (rfqServiceType === 1 || rfqServiceType === 4)) || rfqType === 2 || rfqType === 5) || !disablePlacementTime)?1:2,
            trip: trip,
            isMinimized: false,
            showError: {
                "from": false,
                "to": false
            },
            vehicleDetailsSubmitted: false,
            stopDetailsSubmitted: false,
            biddingDetailsSubmitted: false,
            lppDetails: {},
            routeMasterDetails: []
        }
        this.viewMode = props.viewMode;
    }
    minimizeTrip = ()=> {
        this.setState({
            isMinimized: true
        })
    }
    maximizeTrip = ()=> {
        this.setState({
            isMinimized: false
        })
    }

    nextView = ()=> {
        const { activeView } = this.state;
        const { trip } = this.state;
        const user = getUser();
        const isDPL = DEEPAK_PHENOLICS.includes(user.id);
        const beam = BEAM.includes(user.companyId);
        const isDPLSAP = DEEPAK_PHENOLICS_SAP.includes(user.companyId);
        const { 
            rfqServiceType, 
            rfqType, 
            addTrip,
            rfq
        } = this.props;
        if(BEAM.includes(rfq.companyId) && activeView === 4 && !(trip.biddingDetails || {}).diesel_price ) {
            return;
        }
        if(rfqType === 1 && (rfqServiceType ===1 || rfqServiceType === 4) && activeView === 1 && (isDPL ? (!trip.vehicleType || !trip.vehicleSpecification) : (!trip.vehicleBodyType || !trip.vehicleType || (getUser().showPinCodeDetails ? !trip.truckCapacity : false) || ((isAdaniWilmar() || CENTURY_PLY.includes(user.companyId)) ? !trip.vehicleCapacity : false)))) {
            this.setState({
                vehicleDetailsSubmitted: true
            });
            return;
        }
        else if(rfqType === 1 && (rfqServiceType ===1 || rfqServiceType === 4) && activeView === 2 && (!trip.stops[0].location || (rfq.rfqDetails.ftlContractType === 2 ? (!trip.fromRange || !trip.toRange) : !trip.stops[1].location) || (trip.is_existing_contract ? (!trip.contract_exist_remarks) : false) || ((CARGIL.includes(rfq.companyId) && rfq.rfqDetails.ftlContractType === 1) ? !trip.consigneeType : false))) {
            this.setState({
                stopDetailsSubmitted: true
            });
            return;
        } else if((rfqServiceType === 4 || isDesmet()) && activeView === 2 && (rfq.rfqDetails.ftlContractType === 2 ? false : !trip.consigners[0])) {
            this.setState({
                stopDetailsSubmitted: true
            });
            return;
        } else if(isDesmet() && activeView === 2 && !trip.consignees[0]) {
            this.setState({
                stopDetailsSubmitted: true
            });
            return;
        }
        else if(activeView === 4 && (rfqServiceType === 4 || (rfq  && ['737'].includes(rfq.companyId) && (rfq.contegory_type || []).find(el => el.name == 'LTC') && !rfq.rfqDetails.acceptPartialSolution) || CENTURY_PLY.includes(rfq.companyId) || ([...EMAMI, ...STAR_CEMENT ,...GREEN_PLY].includes(rfq.companyId) && !rfq.rfqDetails.acceptPartialSolution) || ROQUETTE.includes(rfq.companyId))
        && (!trip.biddingDetails.businessVolumeUnit || !trip.biddingDetails.businessVolumeValue)) {
            this.setState({
                biddingDetailsSubmitted: true
            });
            return;
        }
        else if(isAdaniWilmar() && activeView === 2 && !trip.routeCode) {
            this.setState({
                stopDetailsSubmitted: true
            });
            return;
        }
        // else if(activeView === 4 && !(trip.biddingDetails || {}).qbr && GREEN_PLY.includes(rfq.companyId)) {
        //     this.setState({
        //         biddingDetailsSubmitted: true
        //     });
        //     return;
        // }

        if(rfqServiceType === 4 && activeView === 2){
            if(trip.consignees[0] && !trip.consignees[0].consignee_name){
                trip.consignees[0].consignee_details = trip.stops[1];
                trip.consignees[0].consignee_name = trip.stops[1].location;
                trip.consignees[0].consignee_id = '';
            }
            else
            {
                if(!trip.consignees[0])
                {
                    trip.consignees = [];
                    const obj = 
                    {
                        consignee_details: trip.stops[1],
                        consignee_name: trip.stops[1].location,
                        consignee_id: ''
                    }
                    trip.consignees.push(obj);
                }
            }
        }
        if(rfqType === 1 && (rfqServiceType ===1 || rfqServiceType === 4) && activeView === 2) {
            this.props.getQBR({
                vehicle_type: trip.vehicleType,
                vehicle_body_type: !isDPL ? trip.vehicleBodyType : undefined,
                from: trip.stops[0].location,
                to: trip.stops[1].location
            }, (qbr)=> {
                if(!trip.biddingDetails.qbr) {
                    trip.biddingDetails.setQbr(qbr);
                    this.onChange();
                }
            });
            const user = getUser();
            const multiple_routes = [];
            if((trip.stops || []).length > 2 && !(trip.stops || []).find(stop => !stop.location)) {
                multiple_routes.push({
                    source: trip.stops[0].location,
                    destination: trip.stops[2].location
                });
                (trip.stops || []).map((val, index) => {
                    if(index > 1 && index < trip.stops.length-1) {
                        multiple_routes.push({
                            source: val.location,
                            destination: trip.stops[index + 1].location
                        })
                    } else if(trip.stops.length -1 === index) {
                        multiple_routes.push({
                            source: val.location,
                            destination: trip.stops[1].location
                        })
                    }
                })
            }
            const multi_route = {
                multiple_routes: multiple_routes.length > 0 && multiple_routes || undefined,
                multiple_source: multiple_routes.length > 0 && (multiple_routes || []).map(mRoute => mRoute.source).join(' ') || undefined,
                multiple_destination: multiple_routes.length > 0 && (multiple_routes || []).map(mRoute => mRoute.destination).join(' ') || undefined
            }
            if(![...CENTURY_PLY, ...STAR_CEMENT].includes(user.companyId)) {
                this.props.dispatch({
                    type: GET_LPP_DETAILS,
                    data: {
                        rfqType: {
                                companyId: (user && user.companyId) ? user.companyId : null,
                                source: trip.stops[0].location,
                                destination: trip.stops[1].location,
                                vehicle_type: trip.vehicleTypeName,
                                vehicle_Body: !isDPL ? trip.vehicleBodyTypeName : undefined,
                                product_category : isDPL && (rfq.cargoInfo || {}).productCategory  || undefined,
                                ...multi_route,
                                ...((isAdaniWilmar() && rfq.type === 1) ? {
                                    contract_type: (rfq.rfqDetails || {}).contractType,
                                    fuel_type: ((rfq.rfqDetails || {}).fuelTypes) || rfq.fuelType
                                } : {}),
                                pricing_basis: rfq.biddingDetails.pricingBasis,
                                ...(CARGIL.includes(user.companyId) ? { ftl_contract_type: rfq.rfqDetails.ftlContractType } : {}),
                                ...(rfq.rfqDetails.ftlContractType == 2 ? {
                                    ftl_contract_type: rfq.rfqDetails.ftlContractType,
                                    // pricing_basis: rfq.biddingDetails.pricingBasis,
                                    from_range: Number(trip.fromRange),
                                    to_range: Number(trip.toRange)
                                } : {}),
                                ...((rfq.rfqDetails.ftlContractType == 1 && CARGIL.includes(user.companyId)) ? {
                                    consignee_type: trip.consigneeType
                                } : {}),
                                rfq_type: rfq.type
                            }
                    },
                    onSuccess: ((data)=> {
                        this.setState({
                            tripRouteCode:data.rfqType.route_code ? data.rfqType.route_code : null,
                            lppDetails: {
                                ...data.rfqType,
                                ...multi_route
                            }
                        }, () => {
                            const { trip, lppDetails } = this.state;
                            if (lppDetails && Object.keys(lppDetails).length > 0 && lppDetails.distance) {
                                trip.biddingDetails.setTatValue(Math.round(parseFloat(lppDetails.distance.replace(/[\s,]+/g,'')) / (GREEN_PLY.includes(user.companyId) ? (trip.requiredVehicleCapacity > 16 ? 300 : 350) : AVG_DISTANCE)));
                                trip.biddingDetails.setTatUnit({ name:"Days", value:1 });
                                // if(GREEN_PLY.includes(user.companyId)) {
                                //     trip.biddingDetails.setQbr(lppDetails.lpp);
                                // }
                                this.setState({ trip });
                            }
                        });
                        if (((isAdaniWilmar()) && rfq && rfq.biddingDetails && data && data.rfqType && data.rfqType.lpp && data.rfqType.lpp > 0) || ARDEX.includes(user.companyId)) {
                            this.props.dispatch({
                                type: GET_SYSTEM_SUGGESTED_PRICE,
                                data: {
                                    transporters_count: rfq.transportersCount,
                                    vehicle_body_type_name: trip.vehicleBodyTypeName,
                                    vehicle_type_name: trip.vehicleTypeName,
                                    lpp: data.rfqType.lpp,
                                    from: trip.stops[0].location ? (trip.stops[0].location.split(',')[0] || '' ) : (trip.stops[0].city && trip.stops[0].city.split(',')[0] || ''),
                                    to: trip.stops[1].location ? (trip.stops[1].location.split(',')[0] || '' ) : (trip.stops[1].city && trip.stops[1].city.split(',')[0] || ''),
                                    branch_id: rfq.branchId,
                                    pricingBasisId: rfq.biddingDetails.pricingBasis
                                },
                                onSuccess: (data) => {
                                    const { trip } = this.state;
                                    if(data) {
                                        trip.biddingDetails.setSystemSuggestedPrice(data.ssp);
                                        if(!trip.id) {
                                            trip.biddingDetails.setQbr(data.ssp);
                                        }
                                        this.setState({ trip });
                                    }
                                }
                            })
                        } else {
                            const { trip } = this.state;
                            trip.biddingDetails.setSystemSuggestedPrice(0);
                            this.setState({ trip });
                        }
                    })
                })
            }
            if( user.isShowDphDetails){
                const source =( trip.stops[0] || {}).city
                const queryParams = {
                    source
                }
                this.props.dispatch({
                    type: GET_DIESEL_PRICE,
                    data:queryParams,
                    onSuccess: ((data)=> {
                 
                    const dphDetails = data
                    this.setState({dphDetails});
                 })
               })

            }
       
        }
        if(rfqType === 1 && activeView === 2) {
            this.setState({
                activeView: 4
            });
        }
        else if(activeView !== 4) {
            this.setState({
                activeView: activeView + 1
            });
        }
        else if(this.state.activeView === 4) {
            const apiData = this.state.trip.getApiData(rfqType, rfqServiceType);
            apiData.route_code = this.state.tripRouteCode ? this.state.tripRouteCode : (apiData.route_code || null);
            apiData.distance = (CENTURY_PLY.includes(user.companyId) || beam || isDPLSAP) ? this.state.trip.distance : (this.state.lppDetails ? this.state.lppDetails.distance : null);
            apiData.distance_uom = (CENTURY_PLY.includes(user.companyId) || beam|| isDPLSAP) ? this.state.trip.distance_uom : (this.state.lppDetails ? this.state.lppDetails.distance_uom: null);
            apiData.lpp=this.state.lppDetails.lpp || (apiData.bidding_and_payments || {}).lpp;
            apiData.average_lpp = (isAdaniWilmar()) ? (this.state.lppDetails || {}).average_lpp : undefined;
            apiData.pptk_value = GREEN_PLY.includes(user.companyId) ? (this.state.lppDetails || {}).pptk_value : undefined;
            apiData.lpp_previous_date = this.state.lppDetails ? this.state.lppDetails.lpp_date_time : undefined;
            apiData.lpp_previous_vehicle_type = this.state.lppDetails ? this.state.lppDetails.lpp_vehicle_type : undefined;
            apiData.is_km_inserted_by = this.state.lppDetails ? this.state.lppDetails.is_km_inserted_by : null;
            apiData.multiple_destination = this.state.lppDetails ? this.state.lppDetails.multiple_destination : null;
            apiData.multiple_routes = this.state.lppDetails ? this.state.lppDetails.multiple_routes : null;
            apiData.multiple_source = this.state.lppDetails ? this.state.lppDetails.multiple_source : null;
            apiData.multiple_route_distance = this.state.lppDetails ? this.state.lppDetails.multiple_route_distance : null

            if(isDesmet()){
                apiData.recommended_vehicle = trip.recommended_vehicle;
                apiData.consignor_details = {
                    ...trip.consignor_details,
                    ...trip.consigners[0]
                }
                apiData.tentative_pickup_date = trip.tentative_pickup_date;
              }
            if (isGreenPly()) {
                apiData.lot_id = trip.lotId;
                apiData.lot_name = trip.lotName;
            }

            addTrip(apiData, false);
        }
    }
    saveAndKeepAdding = ()=> {
        const { trip, activeView } = this.state;
        const { rfqServiceType, rfqType, addTrip, rfq } = this.props;
        const beam = BEAM.includes(rfq.companyId);
        const isDPLSAP = DEEPAK_PHENOLICS_SAP.includes(rfq.companyId);
        if(BEAM.includes(rfq.companyId) && activeView === 4 && !(trip.biddingDetails || {}).diesel_price ) {
            return;
        }
        if(activeView === 4 && (rfqServiceType === 4 || (rfq  && ['737'].includes(rfq.companyId) && (rfq.contegory_type || []).find(el => el.name == 'LTC') && !rfq.rfqDetails.acceptPartialSolution) || CENTURY_PLY.includes(rfq.companyId) || ([...EMAMI, ...STAR_CEMENT,...GREEN_PLY].includes(rfq.companyId) && !rfq.rfqDetails.acceptPartialSolution) || ROQUETTE.includes(rfq.companyId))
        && (!trip.biddingDetails.businessVolumeUnit || !trip.biddingDetails.businessVolumeValue)) 
        {
            this.setState({
                biddingDetailsSubmitted: true
            });
            return;
        } 
        // else if(GREEN_PLY.includes(rfq.companyId) && activeView === 4 && !(trip.biddingDetails || {}).qbr) {
        //     this.setState({
        //         biddingDetailsSubmitted: true
        //     });
        //     return;
        // }
        const apiData = this.state.trip.getApiData(rfqType, rfqServiceType);
        apiData.route_code = this.state.tripRouteCode ? this.state.tripRouteCode : (apiData.route_code || null);
        apiData.distance = (CENTURY_PLY.includes(rfq.companyId) || beam) ? trip.distance : (this.state.lppDetails ? this.state.lppDetails.distance : null);
        apiData.distance_uom = (CENTURY_PLY.includes(rfq.companyId) || beam) ? trip.distance_uom : (this.state.lppDetails ? this.state.lppDetails.distance_uom: null);
        apiData.lpp=this.state.lppDetails.lpp;
        apiData.average_lpp = ([...KRBL].includes(rfq.companyId) || isAdaniWilmar()) ? (this.state.lppDetails || {}).average_lpp : undefined;
        apiData.pptk_value = GREEN_PLY.includes(rfq.companyId) ? (this.state.lppDetails || {}).pptk_value : undefined;
        apiData.lpp_previous_date = this.state.lppDetails ? this.state.lppDetails.lpp_date_time : undefined;
        apiData.lpp_previous_vehicle_type = this.state.lppDetails ? this.state.lppDetails.lpp_vehicle_type : undefined;
        apiData.is_km_inserted_by= this.state.lppDetails ? this.state.lppDetails.is_km_inserted_by: null;
        apiData.multiple_destination = this.state.lppDetails ? this.state.lppDetails.multiple_destination : null;
        apiData.multiple_routes = this.state.lppDetails ? this.state.lppDetails.multiple_routes : null;
        apiData.multiple_source = this.state.lppDetails ? this.state.lppDetails.multiple_source : null;
        apiData.multiple_route_distance = this.state.lppDetails ? this.state.lppDetails.multiple_route_distance : null;

       if(isDesmet()){
         apiData.recommended_vehicle = trip.recommended_vehicle;
         apiData.consignor_details = {
            ...trip.consignor_details,
            ...trip.consigners[0]
         };
         apiData.tentative_pickup_date = trip.tentative_pickup_date;
       }
        if (isGreenPly()){
            apiData.lot_id = trip.lotId;
            apiData.lot_name = trip.lotName;
        }

        addTrip(apiData, true);
       
    }
    previousView = ()=> {
        const { activeView } = this.state;
        const { rfqType } = this.props;
        if(rfqType === 1 && activeView === 4) {
            this.setState({
                activeView: 2
            });
        } else if(activeView !==1) {
            this.setState({
                activeView: activeView - 1
            })
        }
    }
    onChange = ()=> {
        this.setState({
            trip: this.state.trip
        }, () => {
            const { trip } = this.state;
            this.setState({showError: {
                from: trip.stops[0].location == '',
                to: trip.stops[1].location == ''
            }});
        })
    }
    deleteTrip = ()=> {
        const { trip } = this.state;
        this.props.deleteTrip(trip);
    }

    isRoundTripChange = (isRoundTrip) => {
        const { trip } = this.state;
        trip.isRoundTrip = isRoundTrip;
        this.setState({ trip });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { activeView, trip } = this.state;     
        if( this.props && nextProps.isTripExists && activeView === 4){
            this.setState({ activeView: 1 });
            this.props.resetTripStatus(null);
        }
        if(KRBL.includes(getUser().companyId) && this.props.rfq && ((this.props.rfq || {}).biddingDetails || {}).to && trip && !trip.placementTime) {
            trip.setPlacementTime(((this.props.rfq || {}).biddingDetails || {}).to && (Moment(((this.props.rfq || {}).biddingDetails || {}).to).add(1, 'days').valueOf()) || '');
        }
    }

    getRouteCode = (from, to,rfqType) => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_ROUTE_CODE,
            data: {
                from,
                to,
                companyId: getUser().companyId,
                rfqType
            },
            onSuccess : (data) => {
                const { trip } = this.state;
                trip.routeCode = data.route_code || '';
                trip.addRouteCode(data.route_code);
                this.setState({ trip });
            }
        })
    }

    saveRouteCode = (code) => {
        const { dispatch } = this.props;
        const { trip } = this.state;
        trip.routeCode = code;
        dispatch({
            type: SAVE_ROUTE_CODE,
            data: {
                from: trip.stops[0].location.split(',')[0],
                to: trip.stops[trip.stops.length - 1].location.split(',')[0],
                distance: trip.distance,
                distance_uom: "KM",
                sap_code: code,
                company_id: getUser().companyId,
                is_distance_from_google: (trip && trip.vehicleBodyTypeName)?true: false
            },
            onSuccess: () => {
                trip.addRouteCode(code);
                this.setState({ trip });
            }
        });
    }

    getSAPRouteCodes = (search = null, from, to) => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_SAP_ROUTE_CODES,
            data: {
                companyId: getUser().companyId,
                offset: 0,
                limit: 10,
                search: search || undefined,
                from,
                to
            }
        })
    }

    getPinCode = (value, isDestination) => {
        const { dispatch } = this.props;
        dispatch({
            type: GET_LOCATION_WITH_PINCODE,
            data: {
                [isDestination ? 'destPincode' : 'srcPincode']: value
            }
        })
    }

    getMasterRouteCodeDetails = (from, to) => {
        const { dispatch } = this.props;
        dispatch({
           type: GET_MASTER_ROUTE_CODE_DETAILS,
           params: {
              limit: 20,
              offset: 0,
              from,
              to
           },
           onSuccess: (data) => {
            if(data) {
                this.setState({
                   routeMasterDetails: data
                })
            }
           }
        });
     }

    getTripExistConfirmationPopup = (from, to, tripStopsClear) => {
        const { dispatch, rfq } = this.props;
        const { trip } = this.state;
        const { rfqDetails = {} } = rfq;
        dispatch({
            type: CHECK_FTL_CONTRACT_EXIST,
            data: {
                source: from,
                destination: to,
                vehicle_type_name: trip.vehicleTypeName,
                contract_tenure_from: rfqDetails.contractTenureFrom,
                contract_tenure_to: rfqDetails.contractTenureTo,
                contract_type: rfqDetails.contractType,
                fuel_type: rfqDetails.fuelTypes || rfq.fuelType
            },
            onSuccess: (data) => {
                if(data.contract_existing) {
                    this.setState({
                        isRouteConfirmation: true,
                        removeStops: tripStopsClear,
                        message: `Already Contract Exist For This Route till ${Moment(data.contract_tenure_to || null).format('DD MMM YYYY')}, Still Do You Want To Create A New One? If yes, Enter the remarks.`
                    });
                }
            }
        })
    }

    onCancel = () => {
        this.state.removeStops();
        this.setState({
            isRouteConfirmation: false,
            message: ''
        });
    }   

    onContractConfirm = () => {
        const { trip } = this.state;
        trip.setContractExistForTrip(true);
        this.setState({
            isRouteConfirmation: false,
            message: '',
            trip
        })
    }

    contractExistRemarks = (e) => {
        const { trip } = this.state;
        trip.setContractExistRemarks(e.target.value);
        trip['contract_exist_remarks'] = e.target.value;
        this.setState({
            trip
        });
    }

    render() {
        const { 
            rfqServiceType, 
            rfqType, 
            disablePlacementTime,
            productCategories,
            vehicleTypes,
            vehicleBodyTypes,
            paymentCycles,
            businessVolumes,
            pricingBasis,
            slabs,
            qbr,
            autoSuggestLocations,
            getNetWorkData,
            networkData,
            rfq,
            clusterDetails,
            zoneWiseDetails,
            ftlContractTypeList,
            consignorDetails
        } = this.props;
        const { activeView, trip, isMinimized, showError, vehicleDetailsSubmitted, stopDetailsSubmitted, biddingDetailsSubmitted, isRouteConfirmation, message, routeMasterDetails } = this.state;
        return (
            <Fragment>
                {!isMinimized && <Overlay>
                    <div className="box-shadow br-5 pr flex">
                        <div className="wt-750 pt-20 pb-20 ht-600 overflowAuto">
                            <div className="pl-20 pr-20 pb-50">
                                <div className="flex flex-middle border-bottom-light-2 pb-10">
                                    <Heading text="Add New Trip" className="flex-1"/>
                                    <div className="flex flex-between" >
                                        {trip.id && !this.viewMode && <div className="flex mr-20 curP" onClick={this.deleteTrip}>
                                            <TrashIcon className="theme-fill ht-12 wt-12 mr-5"/>
                                            <span className="theme-color fs-14 fBold">Delete</span>
                                        </div>}
                                        <div className="flex mr-20 curP" onClick={this.props.hideAddTrip}>
                                            <CloseIcon className="theme-fill ht-12 wt-12 mr-5"/>
                                            <span className="theme-color fs-14 fBold">Close</span>
                                        </div>
                                        <div className="flex flex-middle curP" onClick={this.minimizeTrip}>
                                            <MinimizeIcon className="theme-fill ht-12 wt-12 mr-5"/>
                                            <span className="theme-color fs-14 fBold">Minimize</span>
                                        </div>
                                    </div>  
                                </div>
                                <TripStatusBar rfqType={rfqType} className="mt-40 mb-40"/>
                                <div className="pb-20">
                                    {activeView === 1 && 
                                        <VehicleDetails 
                                        vehicleTypes={vehicleTypes} 
                                        vehicleBodyTypes={vehicleBodyTypes} 
                                        disablePlacementTime={disablePlacementTime} 
                                        trip = {trip} 
                                        onChange={this.onChange}
                                        viewMode = {this.viewMode}
                                        submitted= {vehicleDetailsSubmitted}
                                        productCategories={productCategories}
                                        shouldShowVehicleTypes = {(rfqType === 1 && (rfqServiceType === 1 || rfqServiceType === 4)) || rfqType === 2 || rfqType === 5}
                                        rfqServiceType={rfqServiceType}
                                        cargoInfo={rfq.cargoInfo}
                                        rfqDetails={rfq.rfqDetails}
                                    />}
                                    {activeView === 2 && rfqType !== 2 && rfqType !== 5 && (rfqServiceType===1 || rfqServiceType === 4) && 
                                        <StopDetails 
                                            trip = {trip} 
                                            onChange={this.onChange}
                                            viewMode = {this.viewMode}
                                            showError = { showError }
                                            submitted={stopDetailsSubmitted}
                                            autoSuggestLocations={autoSuggestLocations}
                                            rfqServiceType={rfqServiceType}
                                            isRoundTripChange={this.isRoundTripChange}
                                            getNetWorkData={getNetWorkData}
                                            networkData={networkData}
                                            getRouteCode={this.getRouteCode}
                                            saveRouteCode={this.saveRouteCode}
                                            getPinCode={this.getPinCode}
                                            getTripExistConfirmationPopup={this.getTripExistConfirmationPopup}
                                            contractExistRemarks={this.contractExistRemarks}
                                            getSAPRouteCodes={this.getSAPRouteCodes}
                                            rfq={rfq}
                                            clusterDetails={clusterDetails}
                                            zoneWiseDetails={zoneWiseDetails}
                                            ftlContractTypeList={ftlContractTypeList}
                                            masterRouteCodeDetails={routeMasterDetails}
                                            getMasterRouteCodeDetails={this.getMasterRouteCodeDetails}
                                            consignorDetails={consignorDetails}
                                        />}
                                    {activeView === 2 && rfqType !== 2  && rfqType !== 5 && (rfqServiceType === 2 || rfqServiceType === 3) && 
                                        <LCLStopDetails 
                                            trip = {trip} 
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis}
                                            slabs={slabs}
                                            viewMode = {this.viewMode}
                                        />}
                                    {activeView === 2 && (rfqType === 2 || rfqType === 5) && 
                                        <LegDetails 
                                            trip = {trip} 
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis}
                                            slabs={slabs}
                                            viewMode = {this.viewMode}
                                        />}
                                    {activeView === 3 &&  
                                        <Costs 
                                            trip = {trip} 
                                            costs={trip.costs} 
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis}
                                            slabs={slabs}
                                            viewMode = {this.viewMode}
                                        />}
                                    {
                                        activeView === 4 && 
                                        <BiddingDetails 
                                            type={'addTrip'}
                                            biddingDetails = {trip.biddingDetails} 
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis}
                                            slabs={slabs}
                                            viewMode = {this.viewMode}
                                            submitted={biddingDetailsSubmitted}
                                            lppDetails={this.state.lppDetails}
                                            viewType="trip"
                                            rfqServiceType={rfqServiceType}
                                            systemTime={this.props.systemTime}
                                            rfqBiddingDetails={this.props.biddingDetails}
                                            rfq={rfq}
                                            dphDetails ={this.state.dphDetails}
                                        />
                                    }
                                </div>
                                
                            </div>
                            <div className="pa bg-white box-shadow flex b-0 ht-60 flex flex-middle flex-right wt-749">
                                {activeView > 1 && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.previousView}>Previous</button>}
                                {activeView < 4 && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.nextView}>Next</button>}
                                {activeView === 4 && !this.viewMode && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.nextView}>Save And Close</button>}
                                {activeView === 4 && !this.viewMode && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.saveAndKeepAdding}>Save And Keep Adding</button>}
                            </div>
                        </div>
                        <div className="wt-400 ht-600 bg-gray pt-20 pb-20 pl-20 pr-20 overflowAuto ">
                            <Heading text="Live Preview" className="mb-30"/>
                            <img src={TruckPreview} className="wt-350 ht-200 mb-30 " alt="lady"/>
                            <LivePreview 
                                lppDetails={this.state.lppDetails}
                                rfqServiceType={rfqServiceType}
                                rfqType={rfqType} 
                                trip = {trip} 
                                disablePlacementTime={disablePlacementTime} 
                            />
                        </div>
                    </div>
                </Overlay>}
                {
                    isMinimized && <MinimizedTrip maximizeTrip={this.maximizeTrip} hideAddTrip={this.props.hideAddTrip}/>
                }
                {isRouteConfirmation && 
                <Confirmation
                    text = {message}
                    onConfirm={this.onContractConfirm}
                    onCancel={this.onCancel}
                    loiRejectionReason={trip.contract_exist_remarks}
                    placeholder={'Remarks'}
                    hasRemarks={true}
                    onChangeLoiRejectionRemarks={this.contractExistRemarks}
                    remarksMandatory={true}
                />}
            </Fragment>
        )
    }
}

export default connect(null, null)(AddTrip);
